// extracted by mini-css-extract-plugin
module.exports = {"map":"LogoButton_map__1HFL3","wrapper":"LogoButton_wrapper__2xYFG","logo":"LogoButton_logo__FE-nM","title":"LogoButton_title__1f8vv"};